import Index from "@/views/index/index.vue";
const routes = [
    {
        path: '/',
        redirect: '/index',
        meta: { title: "" },
		name: "home",
        children: [
            {
                // path: '/index', component: () => import('@/views/index/index.vue'),
				path: '/index', component: Index,
                meta: { title: "" },
            },
			{
				path: '/goods/index', component: () => import('@/views/goods/index.vue'),
				meta: { title: "商品列表" },
			},
			{
				path: '/goods/view', component: () => import('@/views/goods/view.vue'),
				meta: { title: "" },
			},
			{
				path: '/activity/group/index', component: () => import('@/views/activity/group/index.vue'),
				meta: { title: "拼团活动" },
			},
			{
				path: '/activity/group/view', component: () => import('@/views/activity/group/view.vue'),
				meta: { title: "" },
			},
			{
				path: '/activity/second/index', component: () => import('@/views/activity/second/index.vue'),
				meta: { title: "限时秒杀" },
			},
			{
				path: '/activity/second/view', component: () => import('@/views/activity/second/view.vue'),
				meta: { title: "" },
			},
			{
				path: '/activity/bargain/index', component: () => import('@/views/activity/bargain/index.vue'),
				meta: { title: "砍价活动" },
			},
			{
				path: '/activity/bargain/view', component: () => import('@/views/activity/bargain/view.vue'),
				meta: { title: "" },
			},
			{
				path: '/activity/point/index', component: () => import('@/views/activity/point/index.vue'),
				meta: { title: "积分商品" },
			},
			{
				path: '/activity/point/view', component: () => import('@/views/activity/point/view.vue'),
				meta: { title: "" },
			},
			{
				path: '/activity/limit/index', component: () => import('@/views/activity/limit/index.vue'),
				meta: { title: "限购活动" },
			},
			{
				path: '/activity/limit/view', component: () => import('@/views/activity/limit/view.vue'),
				meta: { title: "" },
			},
			{
				path: '/user/register', component: () => import('@/views/user/register.vue'),
				meta: { title: "用户注册" },
			},
			{
				path: '/user/login', component: () => import('@/views/user/login.vue'),
				meta: { title: "用户登录" },
			},
			{
				path: '/user/forget', component: () => import('@/views/user/forget.vue'),
				meta: { title: "找回密码" },
			},
			{
				path: '/user/bind', component: () => import('@/views/user/bind.vue'),
				meta: { title: "绑定手机" },
			},
			{
				path: '/search/index', component: () => import('@/views/search/index.vue'),
				meta: { title: "搜索内容" },
			},
			{
				path: '/cart/index', component: () => import('@/views/cart/index.vue'),
				meta: { title: "购物车" },
			},
			{
				path: '/cart/confirm', component: () => import('@/views/cart/confirm.vue'),
				meta: { title: "确认订单" },
			},
			{
				path: '/cart/cashier', component: () => import('@/views/cart/cashier.vue'),
				meta: { title: "完成订单" },
			},
			{
				path: '/ucenter/index', component: () => import('@/views/ucenter/index.vue'),
				meta: { title: "会员中心" },
			},
			{
				path: '/ucenter/order/index', component: () => import('@/views/ucenter/order/index.vue'),
				meta: { title: "我的订单" },
			},
			{
				path: '/ucenter/order/detail', component: () => import('@/views/ucenter/order/detail.vue'),
				meta: { title: "订单详情" },
			},
			{
				path: '/ucenter/order/evaluate', component: () => import('@/views/ucenter/order/evaluate.vue'),
				meta: { title: "订单评价" },
			},
			{
				path: '/ucenter/order/refund', component: () => import('@/views/ucenter/order/refund.vue'),
				meta: { title: "订单退款" },
			},
			{
				path: '/ucenter/order/comment', component: () => import('@/views/ucenter/order/comment.vue'),
				meta: { title: "订单评价" },
			},
			{
				path: '/ucenter/invoice/index', component: () => import('@/views/ucenter/invoice/index.vue'),
				meta: { title: "我的发票" },
			},
			{
				path: '/ucenter/address/index', component: () => import('@/views/ucenter/address/index.vue'),
				meta: { title: "收货地址" },
			},
			{
				path: '/ucenter/coupon/index', component: () => import('@/views/ucenter/coupon/index.vue'),
				meta: { title: "优惠券列表" },
			},
			{
				path: '/ucenter/recharge/index', component: () => import('@/views/ucenter/recharge/index.vue'),
				meta: { title: "充值中心" },
			},
			{
				path: '/ucenter/wallet/index', component: () => import('@/views/ucenter/wallet/index.vue'),
				meta: { title: "我的钱包" },
			},
			{
				path: '/ucenter/visit/index', component: () => import('@/views/ucenter/visit/index.vue'),
				meta: { title: "我的足迹" },
			},
			{
				path: '/ucenter/collect/index', component: () => import('@/views/ucenter/collect/index.vue'),
				meta: { title: "我的收藏" },
			},
			{
				path: '/ucenter/user/password', component: () => import('@/views/ucenter/user/password.vue'),
				meta: { title: "修改密码" },
			},
			{
				path: '/page/view', component: () => import('@/views/page/view.vue'),
				meta: { title: "帮助中心" },
			},
			{
				path: '/service/online', component: () => import('@/views/service/online.vue'),
				meta: { title: "客服中心" },
			},
			{
				path: '/shop/index', component: () => import('@/views/shop/index.vue'),
				meta: { title: "商品列表" },
			}
        ],
    },
	{
	    path: '/404',
	    component: () => import('@/views/public/404.vue'),
	    hidden: true
	},
	{
	    path: '/600',
	    component: () => import('@/views/public/600.vue'),
	    hidden: true
	},
	{
	    path: '/601',
	    component: () => import('@/views/public/601.vue'),
	    hidden: true
	},
    {
	    path: '/error',
	    component: () => import('@/views/public/error.vue'),
	    hidden: true
	},
	{ path: '/:pathMatch(.*)*', component: () => import('@/views/public/error.vue') }
];

export default routes
